module.exports = __webpack_public_path__ + "img/about.f105d95b.svg";